import { render, staticRenderFns } from "./RegistrationStep.vue?vue&type=template&id=458fdf4f&scoped=true&"
import script from "./RegistrationStep.vue?vue&type=script&lang=js&"
export * from "./RegistrationStep.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationStep.vue?vue&type=style&index=0&id=458fdf4f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458fdf4f",
  null
  
)

export default component.exports